import { render, staticRenderFns } from "./FacialFeatures.vue?vue&type=template&id=068e9508"
import script from "./FacialFeatures.vue?vue&type=script&lang=js"
export * from "./FacialFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports